<script setup lang="ts">
import { provide } from 'vue';
import ListingEditor from './ListingEditor.vue';
import { UiToaster } from '@shopexperts/shared';

import { createListingDetailsStore } from './composables/useListingDetailsStore';
import { createListingFaqsStore } from './composables/useListingFaqsStore';
import { createListingCustomerStoriesStore } from './composables/useListingCustomerStoriesStore';
import { createListingOfferedServicesStore } from './composables/useListingOfferedServicesStore';
import { createListingPackagedServicesStore } from './composables/useListingPackagedServicesStore';

import {
    ListingDetailsStoreKey,
    ListingFaqsStoreKey,
    ListingCustomerStoriesStoreKey,
    ListingOfferedServicesStoreKey,
    ListingPackagedServicesStoreKey
} from './composables/listingStoreKeys';

const detailsStore = createListingDetailsStore();
const faqsStore = createListingFaqsStore();
const storiesStore = createListingCustomerStoriesStore();
const offeredServicesStore = createListingOfferedServicesStore();
const packagedServicesStore = createListingPackagedServicesStore();

provide(ListingDetailsStoreKey, detailsStore);
provide(ListingFaqsStoreKey, faqsStore);
provide(ListingCustomerStoriesStoreKey, storiesStore);
provide(ListingOfferedServicesStoreKey, offeredServicesStore);
provide(ListingPackagedServicesStoreKey, packagedServicesStore);
</script>
<template>
    <UiToaster>
        <ListingEditor />
    </UiToaster>
</template>